
import $global from 'stores/global'
export default {
  props: {
    shared: {
      type: Boolean,
      default: false
    },
    canShare: {
      type: Boolean,
      default: false
    },
    generating: {
      type: Boolean,
      default: false
    }
  },
  emits: ['share'],
  computed: {
    hidden() {
      return !this.$responsive.desktop && this.$route.name !== 'chat'
    },
    new_btn(){
      return !this.$responsive.desktop  && this.$route.name !== 'new-chat'
    },
  },
  methods: {
    onNewChat() {
      $global.goToChats()
    }
  }
}
